import {
	ThemeProvider as MUIThemeProvider,
} from '@mui/material'
import {
	ErrorBoundary,
} from 'react-error-boundary'
import {
	BrowserRouter,
} from 'react-router-dom'

import {
	materialUICoreTheme,
} from '@/app/config/material-ui'

import {
	PageLoader,
} from '@/shared/components'

import {
	I18nProvider,
} from '../../i18n'
import {
	QueryClientProvider,
} from '../../tan-stack-query'
import {
	ThemeProvider,
} from '../../theme'
import {
	ViewportProvider,
} from '../../viewport'
import type {
	IProviderDefinition,
} from '../types'
import {
	createProviderDefinition,
} from '../utils'

import {
	ErrorFallback,
} from '@/widgets/error-fallback'

export const PROVIDERS_DEFINITIONS: Array<IProviderDefinition> = [
	createProviderDefinition(
		ViewportProvider,
		{
		},
		'viewport',
		1,
	),

	createProviderDefinition(
		ThemeProvider,
		{
			defaultTheme: 'dark' as const,
		},
		'theme',
		2,
	),

	createProviderDefinition(
		MUIThemeProvider,
		{
			theme: materialUICoreTheme,
		},
		'material-ui-theme-provider',
		3,
	),

	createProviderDefinition(
		ErrorBoundary,
		{
			fallback: (
				<ErrorFallback />
			),
		},
		'error-boundary',
		4,
	),

	createProviderDefinition(
		I18nProvider,
		{
			fallback: (
				<PageLoader fullScreen />
			),
		},
		'i18n',
		5,
	),

	createProviderDefinition(
		QueryClientProvider,
		{
		},
		'tan-stack-query',
		6,
	),

	createProviderDefinition(
		BrowserRouter,
		{
		},
		'router',
		7,
	),
]

export const DEV_PROVIDERS_DEFINITIONS: Array<IProviderDefinition> = [
	...PROVIDERS_DEFINITIONS,
]

export const STAGE_PROVIDERS_DEFINITIONS: Array<IProviderDefinition> = [
	...PROVIDERS_DEFINITIONS,
]

export const PROD_PROVIDERS_DEFINITIONS: Array<IProviderDefinition> = [
	...PROVIDERS_DEFINITIONS,
]

export const PROVIDER_DEFINITIONS = {
	ERROR_BOUNDARY: PROVIDERS_DEFINITIONS[0],
	THEME:          PROVIDERS_DEFINITIONS[1],
	I18N:           PROVIDERS_DEFINITIONS[2],
	ROUTER:         PROVIDERS_DEFINITIONS[3],
} as const

